import { DynamicFeed } from '@material-ui/icons';
import React from 'react';

const SkillIcon = ({ color }) => <DynamicFeed style={{ color }} />;

export default SkillIcon;
